import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'donut-chart',
    name: 'Donut chart',
    description: 'A pie or donut chart that shows items with values relative to each other. The widget can be configured to refresh automatically at regular intervals.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-donut-chart" */ "./DonutChartTemplate")),
    icon: generateIconProp('chartPie'),
    complexity: 'easy',
    preLoader: 'donut-chart',
    expectedSchema: 'dictionary-array',
    canDragDropFields: true,
});
